var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('flix-calendar-bold',{attrs:{"language":_vm.$i18n.locale,"calendar":_vm.id,"user":_vm.$getUserVariables().user.md5_id}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }